import { TLBaseShape, RecordProps, T, HTMLContainer, BaseBoxShapeUtil } from "@tldraw/tldraw";
import { mmToPx } from "pages/flyer/builder/utils";

type BlackLineUtilType = TLBaseShape<
  "blackLine",
  {
    w: number;
    h: number;
    fill?: string;
  }
>;

export class BlackLineUtil extends BaseBoxShapeUtil<BlackLineUtilType> {
  static type = "blackLine" as const;
  static props: RecordProps<BlackLineUtilType> = {
    w: T.number,
    h: T.number,
    fill: T.optional(T.string),
  };

  mm = 5;

  isAspectRatioLocked(_shape: BlackLineUtilType): boolean {
    return true;
  }

  getDefaultProps(): { w: number; h: number; fill: string } {
    return {
      w: 0,
      h: 0,
      fill: "#ffffff",
    };
  }
  component(shape: BlackLineUtilType) {
    const borderWidht = mmToPx(this.mm);
    return (
      <HTMLContainer
        style={{
          backgroundColor: "transparent",
          width: shape.props.w,
          height: shape.props.h,
          boxSizing: "border-box",
          boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
          border: `${borderWidht / 2 + 1}px solid ${shape.props.fill}`,
        }}
      ></HTMLContainer>
    );
  }
  indicator(shape: BlackLineUtilType) {
    return this.component(shape);
  }
}
